<!--
 * @Description: 开票维护-邮寄地址
 * @Date: 2025-05-20 15:57:04
-->

<template>
  <BaseForm ref="formRef" label-position="top" :model="formData">
    <div class="form-dialog__title">
      <h1>发票邮寄地址</h1>
      <BaseButton
        size="small"
        :click="onSave"
        v-if="disabled || (!disabled && formData.address.length)"
      >
        {{ disabled ? '编辑' : '保存' }}
      </BaseButton>
      <BaseButton
        size="small"
        type="primary2"
        v-if="!disabled && formData.address.length < 5"
        @click="onAdd"
      >
        新增
      </BaseButton>
    </div>
    <div class="form-dialog__content" style="display: block">
      <BaseCard
        style="margin-bottom: 15px"
        shadow="hover"
        v-for="(item, index) in formData.address"
        :key="index"
      >
        <template #header>
          <div style="display: flex; justify-content: space-between">
            <BaseFormItem
              style="margin-bottom: 0"
              prop=""
              :label="`默认地址${index + 1}`"
              label-position="left"
            >
              <BaseCheckbox
                :disabled="disabled"
                :true-value="1"
                :false-value="0"
                v-model="formData.address[index].isDefault"
                @change="e => onCheckbox(e, index)"
              />
            </BaseFormItem>
            <BaseButton
              size="small"
              type="text"
              v-if="!disabled"
              @click="onRemove(index)"
            >
              删除
            </BaseButton>
          </div>
        </template>
        <BaseFormItem
          label="收件人"
          :prop="createProp(index, 'name')"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
        >
          <BaseInput
            class="form-dialog__w280"
            placeholder="请输入"
            type="text"
            :disabled="disabled"
            v-model="formData.address[index].name"
          />
        </BaseFormItem>
        <BaseFormItem
          label="联系电话"
          :prop="createProp(index, 'phone')"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
        >
          <BaseInput
            class="form-dialog__w280"
            placeholder="请输入"
            type="tel"
            :disabled="disabled"
            v-model="formData.address[index].phone"
          />
        </BaseFormItem>
        <BaseFormItem
          label="邮寄地址"
          :prop="createProp(index, 'mailAddress')"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
        >
          <BaseInput
            class="form-dialog__w280"
            placeholder="请输入"
            type="text"
            :disabled="disabled"
            v-model="formData.address[index].mailAddress"
          />
        </BaseFormItem>
        <BaseFormItem
          label="邮箱"
          :prop="createProp(index, 'email')"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
        >
          <BaseInput
            class="form-dialog__w280"
            placeholder="请输入"
            type="text"
            :disabled="disabled"
            v-model="formData.address[index].email"
          />
        </BaseFormItem>
      </BaseCard>
    </div>
  </BaseForm>
</template>

<script lang="tsx" name="invoice-enterprise-dialog-address" setup>
import { withDefaults, defineProps, ref, watchEffect } from 'vue';
import {
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseCheckbox,
  BaseCard,
  XrkMessage
} from 'xrk-components';
import { BasicInformationData } from '@V/invoice/src/data-source/types';
import { invoicePostalAddressEditor } from '@V/invoice/src/data-source/apis';

type AddressList = BasicInformationData['addressList'];

const props = withDefaults(
  defineProps<{
    remove?: () => {};
    value: AddressList;
  }>(),
  {
    remove() {
      return () => {
        console.log('remove');
      };
    }
  }
);

const formRef = ref(null);
const formData = ref<{ address: AddressList }>({ address: [] });
const disabled = ref(true); // false表示可编辑并按钮变为保存

watchEffect(() => {
  formData.value = { address: props.value };
});

const createProp = (index, key) => {
  return `address.${index}.${key}`;
};

const onAdd = () => {
  formData.value.address.push({
    id: null,
    name: '',
    phone: '',
    address: '',
    mailAddress: '',
    isDefault: 0,
    email: ''
  });
};
const onRemove = index => {
  formData.value.address.splice(index, 1);
};
const onCheckbox = (val, index) => {
  // 只可选中一个，全部改成0再修改目标值
  formData.value.address.forEach((_, index) => {
    formData.value.address[index].isDefault = 0;
  });
  formData.value.address[index].isDefault = val;
};
const onSave = async () => {
  // 保存
  if (!disabled.value) {
    if (!formData.value.address.some(item => item.isDefault)) {
      return XrkMessage.error('请选择默认发票邮寄地址');
    }
    await formRef.value.validate();
    await invoicePostalAddressEditor(formData.value.address);
  }
  disabled.value = !disabled.value;
};
</script>
